type ModuleClientsListParams = {
  integrationName: string;
  moduleName: string;
  tenantId: string;
  page?: number;
  pageSize?: number;
  search?: string;
  moduleStatus?: "active" | "inactive" | null;
  orderBy?: string | null;
  descending?: boolean | null;
};

export const moduleQueryKeys = {
  all: ["integrations"] as const,
  byIntegration: (integrationName: string) =>
    [...moduleQueryKeys.all, integrationName] as const,
  byModule: (integrationName: string, moduleName: string) =>
    [...moduleQueryKeys.byIntegration(integrationName), moduleName] as const,
  clients: (integrationName: string, moduleName: string) =>
    [...moduleQueryKeys.byModule(integrationName, moduleName), "clients"] as const,
  clientsList: (params: ModuleClientsListParams) =>
    [
      ...moduleQueryKeys.clients(params.integrationName, params.moduleName),
      params.tenantId,
      params.page,
      params.pageSize,
      params.search,
      params.moduleStatus,
      params.orderBy,
      params.descending,
    ] as const,
};
